import { Component } from "react";
import Table from 'react-bootstrap/Table';


class PrototypeModelAccuracyTable extends Component {
    static Title = "Prototype model accuracy statistics"
    render() {
        return (
            <Table className='border'>
                <thead className='smoke30-bg'>
                  <tr>
                    <th>Dataset</th>              
                    <th>Samples</th>              
                    <th>R2</th>              
                    <th>RMSE (%)</th>              
                    <th>MAE (%)</th>              
                    <th>Median (Error)</th>              
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Training</td>
                    <td>147</td>
                    <td>0.503</td>
                    <td>15.865</td>
                    <td>12.063</td>
                    <td>-0.444</td>
                  </tr>
                  <tr>
                    <td>Tuning</td>
                    <td>72</td>
                    <td>0.531</td>
                    <td>14.691</td>
                    <td>11.765</td>
                    <td>-0.688</td>
                  </tr>                                  
                </tbody>
            </Table>            
                    );
    }
}
export default PrototypeModelAccuracyTable 